module.exports = __webpack_public_path__ + "static/media/ribbon.736ef4c7.svg";